const Menu = [
  {
    header: "Apps"
  },
  {
    title: "Dashboard",
    group: "apps",
    icon: "assessment",
    name: "Dashboard",
    visibility : true
  },
  {
    title: "Add Category",
    group: "apps",
    icon: "description",
    name: "Add Category",
    visibility : true
  },
  {
    title: "Add Course Category",
    group: "apps",
    name: "Add Course Category",
    icon: "note_add",
    visibility : true
  },
  {
    title: "Create Course",
    group: "apps",
    name: 'Create Course',
    icon: "subject",
    visibility : true,
    items: [{
        title: "Add Course",
        group: "apps",
        name: "Add Course",
        icon: "subject",
        visibility : true
      },
      {
        title: "Course Details",
        group: "apps",
        name: "Add Course Details",
        icon: "playlist_add",
        visibility : true
      },
      {
        title: "Course Videos",
        group: "apps",
        name: "Add Course Videos",
        icon: "videocam",
        visibility : true
      },
      {
        title: "Course Curriculam",
        group: "apps",
        name: "Add Course Curriculam",
        icon: "add_to_photos",
        visibility : true
      },
      {
        title: "Course FAQs",
        group: "apps",
        name: "Add Course FAQs",
        icon: "question_answer",
        visibility : true
      },
      {
        title: "Course Features",
        group: "apps",
        name: "Add Course Features",
        icon: "filter_list",
        visibility : true
      },
      {
        title: "Course Pricing",
        group: "apps",
        name: "Add Course Pricing",
        icon: "money",
        visibility : true
      },
      {
        title: "Course SEO",
        group: "apps",
        name: "Add Course SEO",
        icon: "bar_chart",
        visibility : true
      },
      {
        title: "Company Logo",
        group: "apps",
        name: "Company Logo",
        icon: "work",
        visibility : true
      },      
    ]
  },
  {
    title: "Create Offers",
    group: "apps",
    name: "Create Offers",
    icon: "more",
    visibility : true
  },
  {
    title: "Add Banners",
    group: "apps",
    name: "Add Banners",
    icon: "image",
    visibility : true
  },
  {
    title: "Add Job Listing",
    group: "apps",
    name: "Add Job Listing",
    icon: "work",
    visibility : true
  },
  {
    title: "Applied Jobs List",
    group: "apps",
    name: "Applied Jobs List",
    icon: "local_mall",
    visibility : true
  },
  {
    title: "Add Schedule",
    group: "apps",
    name: "Add Schedule",
    icon: "today",
    visibility : true
  },
  {
    title: "Webinar",
    group: "apps",
    name: "Webinar",
    icon: "aspect_ratio",
    visibility : true
  },
  {
    title: "Webinar Registrations",
    group: "apps",
    name: "Webinar Registrations",
    icon: "chrome_reader_mode",
    visibility : true
  },
  {
    title: "Mini Project",
    group: "apps",
    name: "Mini Project",
    icon: "extension",
    visibility : true
  },
  {
    title: "Fourm",
    group: "apps",
    name: "Fourm",
    icon: "forum"
  },
  {
    title: "Review List",
    group: "apps",
    name: "Review List",
    icon: "rate_review",
    visibility : true
  },
  {
    title: "Activities",
    group: "apps",
    name: "Activities",
    icon: "local_activity",
    visibility : true
  },
  {
    title: "Sales",
    group: "apps",
    name: "Sales",
    icon: "money",
    visibility : true,
    items: [
      {
        title: "All Sales",
        group: "apps",
        name : "Sales",
        visibility : true
      },
      {
        title: "Self Paced Sales",
        group: "apps",
        name: "Self Paced Sales",
        visibility : true
      },
      {
        title: "Classroom Sales",
        group: "apps",
        name: "Classroom Sales",
        visibility : true
      },
      {
        title: "Online Sales",
        group: "apps",
        name: "Online Sales",
        visibility : true
      },
      {
        title: "Project Sales",
        group: "apps",
        name: "Project Sales",
        visibility : true
      },
    ]
  },
  {
    title: "User List",
    group: "apps",
    name: "User List",
    icon: "people",
    visibility : true
  },
  {
    title: "User Registration",
    group: "apps",
    name: "User Registration",
    icon: "person_pin",
    visibility : true
  },
  {
    title: "Trainer List",
    group: "apps",
    name: "Trainer List",
    icon: "perm_identity",
    visibility : true
  },
  {
    title: "Trainer Courses",
    group: "apps",
    name: "Trainer Courses",
    icon: "playlist_add_check",
    visibility : true
  },
  {
    title: "Support",
    group: "apps",
    name: "Support",
    icon: "contact_support",
    visibility : true
  },
  {
    title: "Enquiry",
    group: "apps",
    name: "Enquiry",
    icon: "perm_contact_calendar",
    visibility : true
  },
  {
    title: "Testimonials",
    group: "apps",
    name: "Testimonials",
    icon: "thumb_up_alt",
    visibility : true
  },
  {
    title: "Result Upload",
    group: "apps",
    name: "Result Upload",
    icon: "cloud_upload",
    visibility : true
  },
  {
    title: "Page SEO",
    group: "apps",
    name: "Page SEO",
    icon: "web",
    visibility : true
  },
  {
    title: "Add Users",
    group: "apps",
    name: "Add Users",
    icon: "person_add",
    visibility : true
  }
]
// reorder menu
Menu.forEach(item => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase()
      let textB = y.title.toUpperCase()
      return textA < textB ? -1 : textA > textB ? 1 : 0
    })
  }
})

export default Menu
